import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const dashboardApi = {
  homeDashboardListing: () => {
    const url = "user";
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  homeDashboardListingById:(id)=>{
    const url = `quickapp/v1/user/by/${id}`;
    return request({
        method: HTTP_METHOD.GET,
        url:url,
        useBaseUrl2:true
      });
  },

  mapReportToDashboard: (payload) => {
    const { dashboardId, reportId } = payload;
    const url = `dashboard/${dashboardId}/report/${reportId}/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  reportListing: (dashboardId) => {
    const url = `report/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      params: { dashboardId },
    });
  },
  reportListingDashboard: (dashboardId) => {
    const url = `dashboard/${dashboardId}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  dashboardChartList: (reportId) => {
    const url = `report/${reportId}/chart/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  chartListing: (dashboardId) => {
    const url = `report/chartType/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  reportById: (payload) => {
    const { reportId, queryParameter } = payload;
    const url = `report/${reportId}?${queryParameter}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  businessList: () => {
    const url = `business/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  dashboardGroupList: (businessId) => {
    const url = `dashboard/group/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      params: { businessId },
    });
  },
  dashboardList: (dashboardGroupId) => {
    const url = `dashboard/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      params: { dashboardGroupId },
    });
  },
  reportList: (dashboardId) => {
    const url = `report/list`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  createDashboardGroup: (payload) => {
    const url = `dashboard/group/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  createDashboard: (payload) => {
    const url = `dashboard/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  createReport: (payload) => {
    const url = `report/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  chartCreate: (payload) => {
    const { reportId } = payload;
    const url = `report/${reportId}/chart/create`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
  chartUpdate: (payload) => {
    const { reportId } = payload;
    const url = `report/${reportId}/chart/update`;
    return request({
      method: HTTP_METHOD.PUT,
      url,
      data: payload,
    });
  },
  chartDelete: (payload) => {
    const { reportId, chartId } = payload;
    const url = `report/${reportId}/chart/${chartId}/delete`;
    return request({
      method: HTTP_METHOD.DELETE,
      url,
      data: payload,
    });
  },
  homeDashboardDetail: (payload) => {
    const url = "/home/dashboard";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
    });
  },
};

export default dashboardApi;
